import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { commonMessages } from 'src/utils/messages';

type ViewAllButtonProps = {
    route: string;
    newTab?: boolean;
};

const ViewAllButton = ({ route, newTab = false }: ViewAllButtonProps) => {
    const { formatMessage } = useIntl();

    return (
        <Link to={route} target={newTab ? '_blank' : undefined} rel={newTab ? 'noopener noreferrer' : undefined}>
            <div className="text-primary-700 flex cursor-pointer flex-row items-center gap-1 text-sm font-medium">
                {formatMessage(commonMessages.viewAll)}
            </div>
        </Link>
    );
};

export default ViewAllButton;
